module.exports = __webpack_public_path__ + "static/media/Icon_Imperial.89026487.svg";


//////////////////
// WEBPACK FOOTER
// ./src/media/icons/svg/Icon_Imperial.svg
// module id = 2318
// module chunks = 0